import { useCallback, useMemo } from 'react'
import { useAppDispatch } from 'redux/toolkit/hooks'
import { resetSetupFlowError, saveSetupFlowStep } from 'redux/features/emailServer/emailServerSlice'
import { TRACKING_EVENTS, trackPageLeaveMixpanelEvent } from 'lib/monitoring/monitoringService'
import { SetupFlowCommonSteps, SetupFlowEgdSteps } from '../../types/egdWizardTypes'

export interface EventHandlers {
  onOkay: () => void
}

export type ContinueDialogLogic = [EventHandlers]

export const useContinueDialogLogic = (): ContinueDialogLogic => {
  const dispatch = useAppDispatch()

  const onOkay = useCallback(() => {
    trackPageLeaveMixpanelEvent(TRACKING_EVENTS.SETUP_FLOW.STEP_1_SKIP_CONFIRM)
    dispatch(resetSetupFlowError())
    dispatch(saveSetupFlowStep({ nextStep: SetupFlowEgdSteps.regionSelection, microsoftSkip: true }))
  }, [dispatch])

  return useMemo(
    () => [
      {
        onOkay
      }
    ],
    [onOkay]
  )
}
